import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import RecordPagination from "../../utils/RecordsPagination";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
import { appConstants } from "../../_constants";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  negativeColor: {
    color: "red",
  },
  positiveColor: {
    color: "green",
  },
  neutralColor: {
    color: `rgb(218 194 25)`,
  },
};

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: appConstants.REGIONAL_COLOR,
    fontSize: "14px",
    fontWeight: "lighter",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const WalletRecordsTableStructure = ({ classes, walletRecords }) => (
  <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
    <Table className={classes.table} aria-labelledby="tableTitle">
      <TableHead color="regional">
        <TableRow>
          <CustomTableCell>Airline Name</CustomTableCell>
          <CustomTableCell>Wallet Balance</CustomTableCell>
          <CustomTableCell>Re-order Level</CustomTableCell>
          <CustomTableCell>Airport</CustomTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {walletRecords.map((record, i) => {
          return (
            <TableRow
              hover
              // onClick={event => this.handleClick(event, n.id)}
              // tabIndex={-1}
              key={i}
            >
              <CustomTableCell component="th">{record.Airline}</CustomTableCell>
              <CustomTableCell component="th">
                {record.WalletBalance > record.MinimumThreshold ? (
                  <span className={classes.positiveColor}>
                    {record.CurrencyCode}{" "}
                    {appHelpers.numberWithCommas(record.WalletBalance)}
                  </span>
                ) : record.WalletBalance === record.MinimumThreshold ? (
                  <span className={classes.neutralColor}>
                    {record.CurrencyCode}{" "}
                    {appHelpers.numberWithCommas(record.WalletBalance)}
                  </span>
                ) : (
                  <span className={classes.negativeColor}>
                    {record.CurrencyCode}{" "}
                    {appHelpers.numberWithCommas(record.WalletBalance)}
                  </span>
                )}
              </CustomTableCell>
              <CustomTableCell>
                {record.CurrencyCode}{" "}
                {appHelpers.numberWithCommas(record.MinimumThreshold)}
              </CustomTableCell>
              <CustomTableCell>{record.Airport}</CustomTableCell>
            </TableRow>
          );
        })}
        {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 48 * emptyRows }}>
                        <CustomTableCell colSpan={6} />
                    </TableRow>
                )} */}
      </TableBody>
      {/* <TableFooter>
                <TableRow>
                    <TablePagination
                        colSpan={3}
                        count={data.Results.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        className={classes.pagination}
                    // ActionsComponent={TablePaginationActionsWrapped}
                    />
                </TableRow>
            </TableFooter> */}
    </Table>
  </div>
);

class WalletRecordsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      classes,
      pageSize,
      currentPage,
      fetchWalletRecords,
      totalRecordCount,
      walletRecords,
    } = this.props;

    return (
      <div>
        <RecordPagination
          fetchMore={fetchWalletRecords}
          totalCount={totalRecordCount}
          pageSize={pageSize}
          currentPage={currentPage}
          target={
            <WalletRecordsTableStructure
              classes={classes}
              walletRecords={walletRecords}
            />
          }
        />
      </div>
    );
  }
}

export default withStyles(styles)(WalletRecordsTable);



// WEBPACK FOOTER //
// ./src/Regional-Views/WalletReport/WalletTable.jsx